import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgPower = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 17"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.5 8.5v-5a.5.5 0 1 1 1 0v5a.5.5 0 1 1-1 0m3.773-4.919a.5.5 0 0 0-.546.838C12.17 5.36 13 6.849 13 8.5a5 5 0 1 1-10 0c0-1.652.829-3.14 2.273-4.081a.5.5 0 0 0-.546-.838C2.994 4.711 2 6.504 2 8.5a6 6 0 1 0 12 0c0-1.996-.994-3.789-2.727-4.919"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPower);
export default ForwardRef;
